/** Route-owned low riverbank cover; existing shared templates, wind, pooled
 * materials and compacted per-instance culling. Nothing is regenerated here. */
import * as T from 'three';
import type {ClutterSets} from './clutter';
import type {RiparianData,RiparianKind} from './riparianData';
import {floraHeight,floraTime} from './material';
import {makePooledFloraMesh} from './materialPool';
import {prepareScatterBounds} from './scatterLod';

export function mountRiparian(data:RiparianData,clutter:ClutterSets):{meshes:T.InstancedMesh[]} {
  const meshes:T.InstancedMesh[]=[],groups=new Map<string,{kind:RiparianKind;variant:number;items:RiparianData}>();
  for(const p of data){const key=`${p.kind}:${p.variant}`,group=groups.get(key);if(group)group.items.push(p);else groups.set(key,{kind:p.kind,variant:p.variant,items:[p]});}
  const Y=new T.Vector3(0,1,0),up=new T.Vector3(),position=new T.Vector3(),q=new T.Quaternion(),spin=new T.Quaternion(),scale=new T.Vector3(),matrix=new T.Matrix4();
  for(const {kind,variant,items} of groups.values()){
    const geo=clutter[kind][variant],coarse=kind==='shrub'?clutter.shrubCoarse[variant]:undefined,rigid=kind==='moss'||kind==='litter';
    const fadeFar=kind==='shrub'?300:kind==='fern'?230:kind==='grass'?220:160;
    const mesh=makePooledFloraMesh(geo,items.length,{birth:floraTime(),fadeFar,height:floraHeight(geo),rigid});
    for(let i=0;i<items.length;i++){
      const p=items[i];up.fromArray(p.normal);q.setFromUnitVectors(Y,up).multiply(spin.setFromAxisAngle(Y,p.yaw));
      position.fromArray(p.dir).multiplyScalar(p.radius);scale.set(p.size,p.size*(kind==='grass'?.72:1),p.size);
      mesh.setMatrixAt(i,matrix.compose(position,q,scale));
    }
    mesh.instanceMatrix.needsUpdate=true;
    Object.assign(mesh.userData,{riparianCover:kind,wetlandCover:true,fadeFar,coverEvidence:items,scatterLodNear:85,scatterLodFar:120});
    mesh.castShadow=false;mesh.receiveShadow=true;mesh.visible=false;prepareScatterBounds(mesh,coarse);meshes.push(mesh);
  }
  return {meshes};
}
